'use client';

import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import PortalLayout from '@/components/layout/PortalLayout';
import StudentDashboardContent from './components/StudentDashboardContent';
import { useAuth } from '@/contexts/AuthContext';

const ROLE_ROUTES: Record<string, string> = {
  student: '/student-portal',
  trainer: '/staff-trainer-portal',
  coordinator: '/coordinator-portal',
  executive: '/executive-dashboard',
  sponsor: '/sponsor-portal',
  admin: '/reporting-analytics',
};

export default function HomePage() {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!loading) {
      if (!user) {
        router.replace('/login');
      } else {
        const role = user?.user_metadata?.role || 'student';
        const route = ROLE_ROUTES[role] || '/student-portal';
        // Only redirect if not already on the correct route
        if (role !== 'student') {
          router.replace(route);
        }
      }
    }
  }, [user, loading, router]);

  if (loading || !user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-muted-foreground">Loading…</p>
        </div>
      </div>
    );
  }

  return (
    <PortalLayout
      role="student"
      pageTitle="Student Portal"
      breadcrumb={['SILAG SIMS', 'Student Portal', 'Dashboard']}
    >
      <StudentDashboardContent />
    </PortalLayout>
  );
}